import React, { useEffect } from "react";
import { makeStyles } from "@mui/styles";
import styles from "../../../assets/jss/material-dashboard-pro-react/views/chartsStyle";
import Card from "../../Card/Card";
import CardHeader from "../../Card/CardHeader";
import CardIcon from "../../Card/CardIcon";
import CardBody from "../../Card/CardBody";
import HighchartsReact from "highcharts-react-official";
import Highcharts from "highcharts";
import HC_exporting from "highcharts/modules/exporting";
import HC_export_Data from "highcharts/modules/export-data";
import HC_exportingOff from "highcharts/modules/offline-exporting";
import HC_Heatmap from "highcharts/modules/heatmap";
import HC_BoostCanvas from "highcharts/modules/boost-canvas";
import HC_Boost from "highcharts/modules/boost";
import HC_Accessibility from "highcharts/modules/accessibility";
import HC_More from "highcharts/highcharts-more";
import PropTypes from "prop-types";
import TimelineIcon from "@mui/icons-material/Timeline";
import * as highchartsSankey from "highcharts/modules/sankey";
import * as highChartsDrilldown from "highcharts/modules/drilldown";
import HC_FullScreen from "highcharts/modules/full-screen";
import Button from "@mui/material/Button";
import MenuIcon from "@mui/icons-material/Menu";
import { Menu, MenuItem } from "@mui/material";
import { tooltip } from "assets/jss/material-dashboard-pro-react.js";
import SweetAlert from "react-bootstrap-sweetalert";
import sweetAlertStyle from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js";
import zipcelx from 'zipcelx';
import moment from "moment";

HC_exporting(Highcharts);
HC_export_Data(Highcharts);
HC_Heatmap(Highcharts);
HC_BoostCanvas(Highcharts);
HC_Boost(Highcharts);
HC_Accessibility(Highcharts);
HC_More(Highcharts);
highchartsSankey(Highcharts);
highChartsDrilldown(Highcharts);
HC_exportingOff(Highcharts);
HC_FullScreen(Highcharts);

const style = { tooltip };
const useStyles = makeStyles(styles);
const tooltipStyle = {
    fontSize: '1rem',
    fontFamily: '"Source Sans Pro",sans-serif',
    color: ' #3c4858',
    display: "block", marginTop: "-50px", width: "25rem"
};
const UseSweetAlertStyle = makeStyles(sweetAlertStyle);
const menuButtonStyle = {
    float: "right",
    position: "relative",
    marginRight: "-0.5rem",
    paddingTop: "9px",
    fontFamily: '"Source Sans Pro",sans-serif',
};
const cardHeaderStyle = {
    display: 'flex',
    flexFlow: 'row nowrap',
    justifyContent: 'space-between',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    alignItems: 'flex-start',
};
const menuItemStyle = {
    fontSize: '1.2rem',
    fontFamily: '"Source Sans Pro",sans-serif',
}

function CustomHighCharts(props) {
    console.log(props);
    const classes = useStyles();
    //const toolClasse = tooltipStyle();
    const sweetClasse = UseSweetAlertStyle();
    const [openMenu, setOpenMenu] = React.useState(null);
    const chartRef = React.useRef(null);
    const [alert, setAlert] = React.useState(null);

    useEffect(() => {
        const chart = chartRef.current.chart;
    }, []);

    const downloadPng = () => {
        const chartToExport = { ...props.chartOptions };
        chartToExport.title.text = props.chartTitle;
        chartToExport.width = 600;
        chartRef.current.chart.exportChart({
            type: "image/png",
            filename: props.chartTitle,
        }, chartToExport);
        chartToExport.title.text = "";
        handleClose();
    };

    const downloadCsv = () => {
        chartRef.current.chart.downloadCSV();
        handleClose();
    };

    const downloadXlsx = () => {
        var div = document.createElement('div'),
            name,
            xlsxRows = [],
            rows;
        div.style.display = 'none';
        document.body.appendChild(div);
        rows = chartRef.current.chart.getDataRows(true);
        var datetime = false;
        if (rows.length > 0) {
            if (rows[0][0] === 'DateTime') {
                datetime = true;
            }
        }

        xlsxRows = rows.slice(1).map((row, rowindex) => {
            return row.map((column, index) => {
                if (rowindex > 0 && index === 0 && datetime) {
                    column = moment(column).format("DD/MM/YYYY HH:mm");
                }
                return {
                    type: typeof column === 'number' ? 'number' : 'string',
                    value: column
                };
            });
        });

        console.log(xlsxRows);

        zipcelx({
            filename: props.chartTitle,
            sheet: {
                data: xlsxRows
            }
        });
        handleClose();
    };

    const getFullscreen = () => {
        chartRef.current.chart.fullscreen.toggle();
        handleClose();
    };

    const hideAlert = () => {
        setAlert(null);
    };

    const getTooltipHelp = () => {
        const tooltipAlert = (
            <SweetAlert
                style={tooltipStyle}
                title=""
                onConfirm={() => hideAlert()}
                onCancel={() => hideAlert()}
                confirmBtnCssClass={sweetClasse.button + " " + sweetClasse.info}
            >
                {props.tooltipHelp.split("\n").map((i) => {
                    return <p key={i}>{i}</p>;
                })}
            </SweetAlert>
        );

        setAlert(tooltipAlert);
        handleClose();
    };

    const handleClick = (event) => {
        setOpenMenu(event.currentTarget);
    };

    const handleClose = () => {
        setOpenMenu(null);
    };

    return (
        <div>
            <Card raised={props.simplecard ? false : true} chart style={{ marginTop: '15px', marginBottom: '40px' }}>
                {/* <Card raised={true} chart> */}
                <CardHeader color="success" icon style={cardHeaderStyle}>
                    {props.simplecard ?
                        <></>
                        :
                        <CardIcon color="success" className={classes.cardIcon}>
                            <TimelineIcon />
                        </CardIcon>
                    }
                    <h4 className={props.simplecard ? classes.cardIconTitleSimpleCard : classes.cardIconTitle}>{props.chartTitle}</h4>
                    <div>
                        <Button
                            aria-controls="chart-menu"
                            aria-haspopup="true"
                            onClick={handleClick}
                            justicon={"true"}
                            style={menuButtonStyle}
                        >
                            <MenuIcon />
                        </Button>
                        <Menu
                            id="chart-menu"
                            className={"chart-menu"}
                            anchorEl={openMenu}
                            keepMounted
                            aria-haspopup={'menu'}
                            open={Boolean(openMenu)}
                            onClose={handleClose}
                        >
                            <MenuItem onClick={getTooltipHelp} key={`help_chart${Math.random()}`}>
                                Aide sur le graphique{" "}
                            </MenuItem>
                            <MenuItem onClick={getFullscreen} key={`full_${Math.random()}`}>
                                Plein écran
                            </MenuItem>
                            <MenuItem onClick={downloadPng} key={`downPng_${Math.random()}`}>
                                Télécharger en PNG
                            </MenuItem>
                            <MenuItem onClick={downloadXlsx} key={`downCsv${Math.random()}`}>
                                Télécharger en XLSX
                            </MenuItem>
                            <MenuItem onClick={downloadCsv} key={`downCsv${Math.random()}`}>
                                Télécharger en CSV
                            </MenuItem>
                        </Menu>
                    </div>
                    {alert}
                </CardHeader>

                <CardBody style={{ height: '370px' }}>
                    <HighchartsReact
                        highcharts={Highcharts}
                        options={props.chartOptions}
                        ref={chartRef}
                        containerProps={{
                            style: {
                                position: 'relative',
                                height: '350px',
                            }
                        }}
                    />
                </CardBody>
            </Card>
        </div>
    );
}

CustomHighCharts.propTypes = {
    chartTitle: PropTypes.string,
    chartOptions: PropTypes.shape({
        chart: PropTypes.object,
        title: PropTypes.object,
        subtitle: PropTypes.object,
        legend: PropTypes.object,
        accessibility: PropTypes.object,
        plotOptions: PropTypes.object,
        exporting: PropTypes.object,
        yAxis: PropTypes.array,
        xAxis: PropTypes.object,
        tooltip: PropTypes.object,
        pane: PropTypes.object,
        drilldown: PropTypes.object,
        series: PropTypes.array,
        responsive: PropTypes.object,
    }),
    tooltipHelp: PropTypes.string,
};

export default CustomHighCharts;
